import { gql } from '@apollo/client';

/**
 * GraphQL mutation to delete a standard label
 */
export const DELETE_STANDARD_LABEL = gql`
  mutation DeleteStandardLabel($id: ID!) {
    deleteStandardLabel(id: $id) {
      success
    }
  }
`;
